import { API_BASE_URL } from "@/api/api.config";
import useLazyRestQuery from "@/remoteState/useLazyRestQuery";
import stringifyParams from "@/utils/stringifyParams";

const useStudentPowerWordQuizGet = (queryParams = {}) => {
  const articleId = queryParams?.article_id;
  let resource = `${API_BASE_URL}/api/v2/student-vocabulary-answer/`;
  resource = `${resource}${stringifyParams(queryParams)}`;

  return useLazyRestQuery(resource, { skip: !articleId });
};

export default useStudentPowerWordQuizGet;
